"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DailyDigest_1 = __importDefault(require("./DailyDigest"));
exports.default = DailyDigest_1.default;
